/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { no_key_questions } from "../../forms-config";

/** @param {Question[]} questions */
export const duplicateKeyValidation = (questions) => {



    // get keys from all questions
    const keys = questions.flatMap((question) => {
        if (no_key_questions.includes(question?.type)) {
            return [];
        }
        const keys = question?.key ? [question?.key] : [];
        if (question?.type === "question.grid") {
            keys.push(...(question?.options?.flatMap((option) => option?.key) ?? []));
            keys.push(...(question?.columns?.flatMap((column) => column?.subQuestion?.key) ?? []));
        }
        return keys;
    });

    // check for duplicates
    const duplicateCount = keys.reduce((acc, key) => {
        acc[key] = (acc[key] || 0) + 1;
        return acc;
    }, {});

    const duplicates = Object.entries(duplicateCount)
        .filter(([, count]) => count > 1)
        .map(([key]) => key);
    
    return duplicates
        .map((duplicate) => `Key ${duplicate} is used more than once`);
};
